import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';
import {FormControl} from '@angular/forms';
import { AbuseReportService } from '../../shared/link/abuse-report.service';
import {BehaviorSubject} from 'rxjs';
import {Messages} from '../../messages.enum';
import {finalize} from 'rxjs/operators';
import {HomepageContent} from '../../landing/homepage-content';
import {BackendErrorResponse} from '@common/core/types/backend-error-response';
import * as urlRegex from 'url-regex';

@Component({
    selector: 'abuse-report-form',
    templateUrl: './abuse-report-form.component.html',
    styleUrls: ['./abuse-report-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AbuseReportFormComponent {
    @Input() content: HomepageContent;
    public link = new FormControl();
    public reason = new FormControl();
    public loading$ = new BehaviorSubject<boolean>(false);
    value: any;
    message: string = '';

    constructor(
        private AbuseReportService: AbuseReportService
    ) {}

    async submit() {
        this.loading$.next(true);
        this.message = '';

        if (this.urlInvalid(this.link.value) ||
            !this.link.value.startsWith("http")) {
            // this.toast.open('That is not a valid url');
            this.message = 'That is not a valid url';
            this.loading$.next(false);
            return;
        }

        const payload = {
          reason: this.reason.value,
          link: this.link.value
        };

        // if (!payload.link.startsWith("http")) {
            
        //   this.loading$.next(false);
        //   return this.link.setErrors({
        //     link: this.toast.open('That is not a valid url')
        //   });
        // }

        this.AbuseReportService.create(payload)
            .pipe(finalize(() => this.loading$.next(false)))
            .subscribe(response => {
                console.log('response', response)
                this.reason.setValue('');
                this.link.setValue('');
                this.message = Messages.REPORT_ABUSE_SUCCESS;
                // this.toast.open(Messages.REPORT_ABUSE_SUCCESS, {
                //     action: 'close' 
                // });
            }, (errResponse: BackendErrorResponse) => {
              console.log('error', errResponse)

                this.message = errResponse?.errors?.link || errResponse?.errors?.reason || Messages.REPORT_ABUSE_FAILED
                // this.toast.open(errResponse?.errors?.link || errResponse?.errors?.reason || Messages.REPORT_ABUSE_FAILED, {
                //     action: 'close' 
                // });
            });
    }

    private urlInvalid(url: string) {
        return !urlRegex({exact: true, strict: false}).test(url);
    }
}
